import { render, staticRenderFns } from "./expandable-text.vue?vue&type=template&id=6ef68fcd&scoped=true&"
import script from "./expandable-text.vue?vue&type=script&lang=js&"
export * from "./expandable-text.vue?vue&type=script&lang=js&"
import style0 from "./expandable-text.vue?vue&type=style&index=0&id=6ef68fcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef68fcd",
  null
  
)

export default component.exports